export default "/images/vendor/flag-icon-css/flags/1x1/tt.svg?4252a958aa98bb3ef5f7755b8f0f8736";